import { spacer32 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { List } from "../List";
var TypeListComponent = styled(List).attrs({
  listStyleReset: false
}).withConfig({
  displayName: "TypeList__TypeListComponent",
  componentId: "sc-1jhixr6-0"
})(["padding-inline-start:", ";padding-block-end:", ";"], spacer32, function (props) {
  return props.condensed && '0';
});
var typeListHelpers = {
  ul: TypeListComponent.withComponent('ul'),
  ol: TypeListComponent.withComponent('ol')
};
/**
* **TypeList** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeList) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-type-typelist--default) | [Encore](https://encore.spotify.net/web/components/type?format=figma-figma#list-text) | 
*
* null
*
* @example
* () => (
*  <TypeList>
*    <TypeListItem>
*      Aenean lacinia bibendum nulla sed consectetur. Lorem ipsum dolor sit amet, consectetur
*      adipiscing elit.
*    </TypeListItem>
*    <TypeListItem>
*      Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo
*      luctus.
*    </TypeListItem>
*    <TypeListItem condensed>
*      Condensed item - Etiam porta sem malesuada magna mollis euismod.
*    </TypeListItem>
*  </TypeList>
*);
*
*/

export var TypeList = Object.assign(TypeListComponent, typeListHelpers);
export default TypeList;